import { Badge, Card } from "./ui";

// Иллюстрация механики "Аптайм" для неавторизованного посетителя — синтетический пример,
// не реальные данные пользователя (реальный виджет — StreakWidget).
const WEEKS = [1, 1, 1, 1, 1, 1, "gap", 1, 1, 1, 1, 1, 1, 1, 1, 1, 1] as const;

export function StreakExample() {
  return (
    <Card className="p-5">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-text-muted">Так выглядит Аптайм</span>
        <Badge variant="neutral">пример</Badge>
      </div>
      <div className="mb-3 flex items-end gap-1">
        {WEEKS.map((w, i) =>
          w === "gap" ? (
            <span key={i} className="h-8 flex-1 rounded-full border-2 border-dashed border-risk/50" />
          ) : (
            <span key={i} className="h-8 flex-1 rounded-full bg-brand" />
          )
        )}
      </div>
      <div className="mb-3 flex items-center justify-between text-xs text-text-muted">
        <span>Пропуск 12 мая — болезнь</span>
        <span className="font-medium text-text">11 недель без пропусков</span>
      </div>
      <p className="text-xs text-text-muted">
        Пропуск не закрывается, а обводится пунктиром: это инцидент с причиной, а не провал.
      </p>
    </Card>
  );
}
